import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { toggleLiked } from "redux/modules/postSlice";
import PostImages from "../../PostImages";
import { Boldline } from "../../common/commonStyle";
import { Container, Category, Content, Aside } from "./style";

function SearchRender({ post, correctKeyWord }) {
  const dispatch = useDispatch();
  const replaceNumber = Number(post.likeCount.replace(/(^0+)/, ""));
  const [likeCount, setLikeCount] = useState(replaceNumber);
  const [isLiked, setIsLiked] = useState(post.isLiked);
  const trimKeyWord = correctKeyWord.trim().replace(/ +(?= )/g, "");
  const correctKeyWordIndex = post.content.indexOf(trimKeyWord);

  const onClickToggleLiked = useCallback(() => {
    setIsLiked(true);
    setLikeCount((prev) => prev + 1);

    dispatch(toggleLiked(post.boardId));
  }, [dispatch, post.boardId]);

  const onClickToggleUnLiked = useCallback(() => {
    setIsLiked(false);
    setLikeCount((prev) => prev - 1);

    dispatch(toggleLiked(post.boardId));
  }, [dispatch, post.boardId]);

  return (
    <>
      <Container key={post.boardId}>
        <Category>
          <div className="category">{post.category}</div>
          <div className="createAt">{post.createdDate}</div>
        </Category>

        <Link to={`/boards/${post.boardId}`}>
          <Content>
            {post.content.length > 50 ? (
              <>
                <span className="keyWord">
                  {post.content.substring(
                    correctKeyWordIndex,
                    correctKeyWordIndex + trimKeyWord.length,
                  )}
                </span>
                {post.content.substr(
                  correctKeyWordIndex + trimKeyWord.length,
                  post.content.length - correctKeyWordIndex > 50
                    ? 50 - trimKeyWord.length
                    : 50,
                )}
                {post.content.length - correctKeyWordIndex > 50 && "..."}
              </>
            ) : (
              <>
                {post.content.substring(0, correctKeyWordIndex)}
                <span className="keyWord">
                  {post.content.substring(
                    correctKeyWordIndex,
                    correctKeyWordIndex + trimKeyWord.length,
                  )}
                </span>
                {post.content.substring(
                  correctKeyWordIndex + trimKeyWord.length,
                )}
              </>
            )}
          </Content>
          {post.images[0] && <PostImages images={post.images} />}
        </Link>

        <Aside>
          <span className="nickName">{post.nickname}</span>
          <span className="aside__icons">
            <div className="likedDiv">
              {isLiked ? (
                <img
                  src="/img/likedFull.svg"
                  alt="좋아요"
                  onClick={onClickToggleUnLiked}
                />
              ) : (
                <img
                  src="/img/liked.svg"
                  alt="좋아요"
                  onClick={onClickToggleLiked}
                />
              )}
            </div>
            <div className={isLiked ? "orange" : "black"}>{likeCount}</div>
            <div className="commentsDiv">
              <img className="comments" src="/img/comment.svg" alt="comments" />
            </div>
            <div>{post.commentCount}</div>
          </span>
        </Aside>
      </Container>
      <Boldline />
    </>
  );
}

export default SearchRender;
